<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <text
            x="12" y="17" text-anchor="middle"
            font-family="Roboto, '-apple-system', 'Helvetica Neue', Helvetica, Arial, sans-serif"
            font-weight="400" font-size="14" fill="currentColor"
            style="text-transform: none;">Aa</text>
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults( defineProps<Props>(), {
    size: 36
} )
</script>
